import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { SiteLayout } from '@/layouts/SiteLayout'
import { HomePage } from '@/pages/HomePage'
import { CalculatorPage } from '@/pages/CalculatorPage'
import { AboutPage } from '@/pages/AboutPage'
import { InfoPage } from '@/pages/InfoPage'
import { LegalPage } from '@/pages/LegalPage'
import { ContactPage } from '@/pages/ContactPage'
import { ScrollToTop } from '@/components/ScrollToTop'
import { getAppBasename } from '@/utils/appBase'

export default function App() {
  return (
    <BrowserRouter basename={getAppBasename()}>
      <ScrollToTop />
      <Routes>
        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />
          <Route path="hesaplama" element={<CalculatorPage />} />
          <Route path="hakkimizda" element={<AboutPage />} />
          <Route path="bilgilendirme" element={<InfoPage />} />
          <Route path="yasal-uyari" element={<LegalPage />} />
          <Route path="iletisim" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
